import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { ObjectValues } from "utils"
import { FoodCard, FoodModal, VirtualGrid } from "components"
import classes from "./FoodsList.module.scss"

const breakPoints = [
  {
    point: 1200,
    numberOfColumns: 6
  },
  {
    point: 991,
    numberOfColumns: 5
  },
  {
    point: 768,
    numberOfColumns: 4
  },
  {
    point: 576,
    numberOfColumns: 3
  },
  {
    point: 0,
    numberOfColumns: 2
  }
]

const FoodsList = (props) => {
  const { searchedFoods } = props

  const [t] = useTranslation()

  const foodsMap = useSelector(state => state.foods)

  const [openModal, setOpenModal] = useState(false)
  const [selectedFood, setSelectedFood] = useState(null)

  const data =
    searchedFoods || ObjectValues(foodsMap)

  return (
    <Fragment>
      <VirtualGrid
        offset={2}
        keyField="_id"
        breakPoints={breakPoints}
        data={data}
        sameHeightAndWidth
        className={classes["grid"]}
        listEmptyComponent={
          <div className={classes["no"]}>
            {t("هیچ_کالایی_یافت_نشد")}
          </div>
        }
        renderItem={(filteredFood) =>
          <FoodCard
            food={filteredFood}
            setOpenModal={setOpenModal}
            setSelectedFood={setSelectedFood}
          />
        }
      />
      {
        selectedFood !== null &&
        <FoodModal
          food={selectedFood}
          openModal={openModal}
          setOpenModal={setOpenModal}
          onExited={() => setSelectedFood(null)}
        />
      }
    </Fragment>
  )
}

export default FoodsList